document.addEventListener('DOMContentLoaded', function () {
	if (window.innerWidth < 1200) {
		var currentLanguageLink = document.querySelector('.wpml-ls-current-language > a:first-of-type');
		if (currentLanguageLink) {
			currentLanguageLink.setAttribute('href', 'javascript:void(0);');
		}

		var currentLanguageElement = document.querySelector('.wpml-ls-current-language');
		if (currentLanguageElement) {
			currentLanguageElement.addEventListener('click', function () {
				var subMenu = currentLanguageElement.querySelector('.sub-menu');
				if (subMenu) {
					subMenu.classList.toggle('active');
				}
			});
		}
	}
});

document.addEventListener("DOMContentLoaded", function () {
	document.querySelector(".site-header__humburger-menu a").addEventListener("click", function () {
		var menu = document.querySelector('.site-header__right-menu');
		if (menu.style.display === "none" || menu.style.display === "") {
			menu.style.display = "block";
		} else {
			menu.style.display = "none";
		}
	});

	document.querySelector(".site-header .site-header__inner .site-header__right-menu>ul>li.wpml-ls-menu-item>a").addEventListener("click", function () {
		var menu = document.querySelector('.site-header .site-header__inner .site-header__right-menu>ul>li.wpml-ls-menu-item>ul');
		if (menu.style.display === "none" || menu.style.display === "") {
			menu.style.display = "block";
		} else {
			menu.style.display = "none";
		}
	});

});

document.addEventListener('DOMContentLoaded', function () {
	var links = document.querySelectorAll('.menu-item-has-children > a');

	links.forEach(function (link) {
		link.addEventListener('click', function (e) {
			if (window.innerWidth <= 1200) {
				e.preventDefault();
				var targetName = e.target.nodeName.toLowerCase();
				var parentLi = this.closest('li');

				if (targetName != 'a') {
					if (!parentLi.classList.contains('show-menu')) {
						var allMenuItems = document.querySelectorAll('.menu-item');
						allMenuItems.forEach(function (item) {
							item.classList.remove('show-menu');
						});
						parentLi.classList.add('show-menu');
					} else {
						parentLi.classList.remove('show-menu');
					}
				} else {
					var linkUrl = this.getAttribute('href');
					window.location.href = linkUrl;
				}
			}
		});
	});
});

document.addEventListener('DOMContentLoaded', function () {
    var wpmlLsItemToggle = document.querySelector('.wpml-ls-item-toggle');
    var wpmlLsSubMenu = document.querySelector('.wpml-ls-sub-menu');

    function isMobileView() {
        return window.innerWidth <= 768;
    }

    if (wpmlLsItemToggle && wpmlLsSubMenu && isMobileView()) {
        wpmlLsItemToggle.addEventListener('click', function () {
            if (wpmlLsSubMenu.style.display === 'none' || wpmlLsSubMenu.style.display === '') {
                wpmlLsSubMenu.style.display = 'block';
            } else {
                wpmlLsSubMenu.style.display = 'none';
            }
        });
    }
});